/**
 * @fileoverview Pricing Feature i18n - Paraglide 기반 메시지 집합
 * FSD Features Layer에서 Paraglide 메시지를 일관되게 사용할 수 있도록 구조화합니다.
 */ import * as m from '@paraglide/messages';
// 🔖 고유 네임스페이스 - 기존 Paraglide 키와 정렬
export var PRICING_NAMESPACE = 'pricing';
// 📦 Paraglide 메시지를 기능 단위로 구성한 객체
export var pricingMessages = {
    branding: {
        logo: m.pricing_branding_logo
    },
    header: {
        title: m.pricing_header_title,
        subtitle: m.pricing_header_subtitle,
        greeting: m.pricing_header_greeting
    },
    buttons: {
        login: m.pricing_buttons_login,
        selectPlan: m.pricing_buttons_selectPlan,
        currentPlan: m.pricing_buttons_currentPlan,
        processing: m.pricing_buttons_processing
    },
    subscription: {
        current: m.pricing_subscription_current
    },
    features: {
        title: m.pricing_commonFeatures_title,
        items: {
            cloudIde: m.pricing_commonFeatures_cloudIde,
            realTimeCollaboration: m.pricing_commonFeatures_realTimeCollaboration,
            versionControl: m.pricing_commonFeatures_versionControl,
            autoBackup: m.pricing_commonFeatures_autoBackup,
            multiLanguageSupport: m.pricing_commonFeatures_multiLanguageSupport,
            pluginEcosystem: m.pricing_commonFeatures_pluginEcosystem
        }
    }
};
// 📚 Features 패키지 외부에서 일관된 접근을 위해 alias 제공
export var pricingResources = pricingMessages;
